import React from "react";
import styled from "styled-components";
import { Spinner } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useHubCardLivePreview } from "src/hooks/useHubCardLivePreview";
import { mapEatAndPlayMenu } from "src/utils/mapEatAndPlay";
import { eatAndPlayLivePreviewRequestHandler } from "src/utils/eatAndPlayLivePreviewHandler";
import TabContent from "src/components/EatAndPlay/TabContent";

/**
 * Payload Live Preview iframe target for `eat-and-play-menus`.
 * Always available for CMS editors — independent of REACT_APP_PAYLOAD_SOURCES.
 */
const EatAndPlayPreview = () => {
  const { t, i18n } = useTranslation();
  const { card, isLoading } = useHubCardLivePreview(
    "eat-and-play",
    {
      depth: 0,
      mapDoc: mapEatAndPlayMenu,
      requestHandler: eatAndPlayLivePreviewRequestHandler,
      forceEnabled: true,
    },
    i18n.language
  );

  return (
    <PreviewPage>
      {isLoading ? (
        <div className="preview-status">
          <Spinner animation="border" variant="light" role="status">
            <span className="visually-hidden">{t("loading")}</span>
          </Spinner>
        </div>
      ) : !card ? (
        <div className="preview-status">
          <p>{t("eatAndPlay.preview.waitingForDocument")}</p>
        </div>
      ) : (
        <TabContent categoryKey={card.key || "cashMenu"} t={t} payloadMenu={card} />
      )}
    </PreviewPage>
  );
};

const PreviewPage = styled.div`
  min-height: 100vh;
  background: var(--black);
  color: var(--white);
  box-sizing: border-box;
  padding: 2rem 0 4rem;

  .preview-status {
    width: 100%;
    text-align: center;
    color: var(--mutedwhite);
    padding: 3rem 1rem;
  }
`;

export default EatAndPlayPreview;
